"use strict";

/**
 * Предоставляет инструменты для работы с буфером обмена через Веб-агент. Например, скопировать ссылки в буфер обмена.
 *
 * @namespace window.Core.clipboard
 * @since 5.4.0.1000
 */
(function (global) {
  global.clipboard = {};

  /**
   * Копирует ссылки в буфер обмена
   * @param  {Array<obj>} links Массив ссылок вида {ID:..., Type:..., CompCode:..., Description}}
   */
  function copyLinksToClientBuffer(links) {
    var textHtml = "";
    var textPlain = MakeHrefsFromLinks(links);
    links.forEach(function(link) {
      textHtml += '<a href="';
      textHtml += MakeHref(link);
      textHtml += '">';
      textHtml += link.Description.escapeHtml();
      textHtml += '</a><br/>';
    });

    clipboard.copy({
      "text/html": textHtml,
      "text/plain": textPlain
    });

    return links.length;
  }

  /**
   * Копирует ссылки в хранилище сессии
   *
   * @function copyLinksInSessionStorage
   * @param  {Array<Object>} links Массив ссылок вида {ID:..., Type:..., CompCode:..., Description}}
   * @return {Deferred<Object>} Результат копирования
   * @see https://api.jquery.com/category/deferred-object/
   */
  function copyLinksInSessionStorage(links) {
    var d = $.Deferred();
    CallService("/Session.asmx/CopyLinks", { Links: convertAgentLinksToLinkModels(links) }, function (res) {
      if (res.Success) {
        d.resolve(res);
      }
      else {
        d.reject(res);
      }
    });
    return d.promise();
  }

  /**
   * Скопировать массив ссылок в буфер обмена.
   *
   * @method window.Core.clipboard#copyLinksToClipboard
   * @param  {Array<Object>} links Массив ссылок вида {ID:..., Type:..., CompCode:..., Description}}
   * @return {Deferred<Number>} Количество скопированных ссылок.
   * @see https://api.jquery.com/category/deferred-object/
   */
  global.clipboard.copyLinksToClipboard = function (links) {
    var d = $.Deferred();
    var copiedLinksCount = 0;

    //Если ничего не скопировано, то сразу выходим
    if (!(links) || !(links.length > 0)) {
      d.resolve(copiedLinksCount);
      return;
    }

    //Если мы в IE
    if (WA.ENV.browser.name === 'IE') {
      WebAccess.agent.isPluginAvailable("Clipboard").always(function(isAvailableResponse) {
        //Если агент доступен, копируем через него
        if (isAvailableResponse) {
          copyLinksInSessionStorage(links);
          WebAccess.agent.clipboard.copyLinksToClipboard(links).done(function (res) {
            d.resolve(res);
          }).fail(function (res) {
            d.reject(res.Error);
          });
        } else {
          //Если агент не доступен, то хотя бы в сессию копируем + HTML5 скопирует адрес к объекту
          copiedLinksCount = copyLinksToClientBuffer(links);
          copyLinksInSessionStorage(links).done(function(res) {
            d.resolve(res.Result);
          }).fail(function(res) {
            d.reject(res.Error);
          });
        }
      });
    } else {
      //Копируем ссылки через HTML5 + серверные инструменты
      copiedLinksCount = copyLinksToClientBuffer(links);
      copyLinksInSessionStorage(links).done(function (res) {
        d.resolve(res.Result);
      }).fail(function (res) {
        d.reject(res.Error);
      });
    }
      
    return d.promise();
  },
  
  /**
   * Скопировать текст в буфер обмена.
   *
   * @method window.Core.clipboard#copyLinksToClipboard
   * @param  {string} text Текст для помещения в буфер обмена
   */
  global.clipboard.copyTextToClipboard = function(text) {
    clipboard.copy({
      "text/plain": text
    });
  }

  /**
    * Получает массив объектов ссылок из буфера обмена.
    * @method window.Core.clipboard#getLinksFromClipboard
    * @return {array} Массив объектов ссылок.
    */
  global.clipboard.getLinksFromClipboard = function () {
    return WebAccess.agent.clipboard.getLinksFromClipboard();
  }

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

})(window.Core);